import * as $ from 'jquery';
import * as q from 'q';
import * as globalConfig from 'globalConfig';

class RecaptchaService {
    recaptchaEnabled: boolean;
    processRecaptcha: (successCallback: ((token: string) => void), failCallback: (() => void), jquery: JQueryStatic) => void;

    constructor() {
        this.recaptchaEnabled = (window as any).enableRecaptcha;
        this.processRecaptcha = (window as any).processRecaptcha;
    }

    performRecaptchaCheck(successCallback: ((token: string) => void), failCallback: (() => void)) {
        // just transparently go to success so calling code doesn't need to wrap
        if (!this.recaptchaEnabled) {
            successCallback(null);
        } else {
            this.processRecaptcha(successCallback, failCallback, $);
        }
    }
}

var service = new RecaptchaService();
export { service as RecaptchaService };
